module.exports = __webpack_public_path__ + "img/product-connect-icon.00ff9db2.svg";